module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.imgCropload),
      expression: "imgCropload",
      modifiers: {
        "body": true
      }
    }],
    staticClass: "imgCropBox flex flex-align-center flex-pack-center"
  }, [_c('div', {
    staticClass: "imgCrop",
    attrs: {
      "id": "imgCrop"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("图片裁剪")]), _vm._v(" "), _c('div', {
    staticClass: "oldImgBox clearfix"
  }, [_c('div', {
    staticClass: "oldImg left flex flex-align-center flex-pack-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.oldImg,
      "alt": "原图片",
      "id": "targetImg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "btnGroup"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeCrop
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-38c49ced","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/imgCrop/imgCrop.vue
// module id = 940
// module chunks = 1